module.exports = "/assets/images/like_e874a4.svg";